import { GetOrdersResult, Order, OrderState } from "../../domain";
import {
  Endpoints,
  OrdersRemoteDataSourceError,
  RemoteDataSource,
} from "../core";

export class OrdersRemoteDataSource extends RemoteDataSource {
  public async edit(
    id: string,
    state: OrderState,
    postalTrackingCode?: string
  ): Promise<void> {
    try {
      await this.post(Endpoints.editOrder, {
        body: {
          id,
          state,
          ...(postalTrackingCode === undefined
            ? {}
            : { postal_tracking_code: postalTrackingCode }),
        },
      });
    } catch (error) {
      if (!error.response) throw OrdersRemoteDataSourceError.networkError();
      throw OrdersRemoteDataSourceError.serverError();
    }
  }

  public async list(
    page: number,
    state: OrderState | "ALL",
    startDate?: string,
    endDate?: string,
    search?: string
  ): Promise<GetOrdersResult> {
    try {
      const res = await this.get(Endpoints.listOrders, {
        page,
        ...(startDate !== undefined ? { startDate } : {}),
        ...(endDate !== undefined ? { endDate } : {}),
        ...(state === "ALL" ? {} : { state }),
        ...(search === undefined ? {} : { search }),
      });
      return {
        orders: res.data.orders.map((json: any) =>
          new Order().deserialize(json)
        ),
        ordersCount: res.data.count,
        pageSize: res.data.page_size,
      };
    } catch (error) {
      if (!error.response) throw OrdersRemoteDataSourceError.networkError();
      throw OrdersRemoteDataSourceError.serverError();
    }
  }

  public async sendOrderInfoSms(id: string): Promise<void> {
    try {
      await this.post(Endpoints.sendOrderInfo, { body: { id } });
    } catch (error) {
      if (!error.response) throw OrdersRemoteDataSourceError.networkError();
      throw OrdersRemoteDataSourceError.serverError();
    }
  }

  public async toggleIsPackaged(id: string): Promise<void> {
    try {
      await this.patch(Endpoints.toggleIsPackaged, { body: { id } });
    } catch (error) {
      if (!error.response) throw OrdersRemoteDataSourceError.networkError();
      throw OrdersRemoteDataSourceError.serverError();
    }
  }
}
